import React from "react";
import BaseIcon from "../../utils/BaseIcon";

var DoctorGraphicIcon = function DoctorGraphicIcon(props) {
  var iconFill = "currentColor";
  return /*#__PURE__*/React.createElement(BaseIcon, props, /*#__PURE__*/React.createElement("path", {
    fill: iconFill,
    fillRule: "evenodd",
    d: "M8.488 8.384a5.384 5.384 0 1110.767 0 5.384 5.384 0 01-10.767 0zM13.872 2a6.384 6.384 0 100 12.767 6.384 6.384 0 000-12.767zM1 10.846a1.105 1.105 0 112.21 0 1.105 1.105 0 01-2.21 0zm3.15-.497a2.105 2.105 0 10-.001 1 3.5 3.5 0 013.34 3.497v2.804a11.232 11.232 0 00-3.66 4.213.5.5 0 10.893.448 10.233 10.233 0 012.766-3.416v1.183a2.5 2.5 0 002.5 2.5h2.884a1.5 1.5 0 001.5-1.5v-.668a4.245 4.245 0 003.54-2.918 10.22 10.22 0 015.103 4.806.5.5 0 10.893-.449 11.232 11.232 0 00-5.802-5.36c.006-.098.01-.196.01-.294a.5.5 0 00-.997-.055 11.231 11.231 0 00-3.247-.48.5.5 0 100 1c1.058 0 2.104.164 3.102.482a3.246 3.246 0 01-5.396 1.347 3.244 3.244 0 01-.95-2.294.5.5 0 10-1 0 4.244 4.244 0 003.744 4.215v.668a.5.5 0 01-.5.5H9.988a1.5 1.5 0 01-1.5-1.5v-5.232A4.5 4.5 0 004.15 10.35z",
    clipRule: "evenodd"
  }));
};

DoctorGraphicIcon.displayName = "DoctorGraphicIcon";
DoctorGraphicIcon.defaultProps = {
  size: 48
};
DoctorGraphicIcon.displayName = "DoctorGraphicIcon";
DoctorGraphicIcon.iconName = "Doctor";
export default DoctorGraphicIcon;